import { render, staticRenderFns } from "./Actionable.vue?vue&type=template&id=88499cd2&"
import script from "./Actionable.vue?vue&type=script&lang=js&"
export * from "./Actionable.vue?vue&type=script&lang=js&"
import style0 from "./Actionable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports